<template lang="pug">
  .columns.is-vcentered
    .column.is-3-desktop
    .login.column.is-6
      section.section
        img.login-logo(:src="ecoinventLogo")
        .content
          h3 {{ $t('Data Converter Email Confirmation') }}
        form(@submit.prevent="confirmEmail")
          b-field(:label="$t('E-Mail')")
            b-input(type="email" v-model="email" @input="clearError" disabled)
          transition(name="fade")
            .error(v-if="errorMessage" key="errorMessage")
              p.is-danger {{ errorMessage }}
          .has-text-centered
            input.button.is-vcentered.is-primary.is-outlined(type="submit" :value="$t('Confirm Email')")
          // .has-text-centered
            a(href='signup.html') {{ $t('Sign up for a new account') }}
    .column.is-3-desktop
</template>

<script>
import { verifyEmail } from '../utils/api'

export default {
  name: 'VerifyEmail',
  data() {
    return {
      email: '',
      token: '',
      errorMessage: null,
      ecoinventLogo: require('../assets/ecoinvent Brand mark.png')
    }
  },
  mounted() {
    this.email = this.$route.params.email
    this.token = this.$route.params.token
  },
  methods: {
    confirmEmail() {
      verifyEmail(this.email, this.token)
        .then(() => {
          this.$toast.open({
            message: this.$t('Thank you! You can now login using your email address and password.'),
            duration: 5000,
            type: 'is-success'
          })
          this.$router.push('/')
        })
        .catch(() => {
          this.errorMessage = this.$t('An error occurred while veryfying your email. Please try again later or contact support.')
        })
    },
    clearError() {
      this.errorMessage = null
    }
  }
}
</script>

<style scoped lang="scss">
  .login {
    height: 80vh;
  }

  .button {
    margin-top: 20px;
    margin-bottom: 20px;
    min-width: 150px;
  }

  .login-logo {
    margin: 0 2rem 5rem;
    max-height: 100px;
  }

  .is-danger {
    color: #e01a1a;
  }
</style>



// WEBPACK FOOTER //
// src/components/VerifyEmail.vue